// The engagement panel of the counterparty form (TX-US-0037): the seven answers, each under
// its question with what it should cover. All are required, and the API is the authority.

import { ENGAGEMENT_FIELDS, MAX_ANSWER_LENGTH } from './engagement.js';

export default function EngagementFields({ draft, onChange }) {
  return (
    <fieldset className="engagement">
      <legend>Engagement</legend>
      <p className="hint">Every answer is required.</p>
      {ENGAGEMENT_FIELDS.map((field) => (
        <label className="field" key={field.name}>
          <span className="field-label">{field.label}</span>
          <small className="field-hint">{field.hint}</small>
          {/* Named explicitly: the wrapping label's own name would run on into the hint. */}
          <textarea
            aria-label={field.label}
            value={draft[field.name]}
            onChange={(event) => onChange({ ...draft, [field.name]: event.target.value })}
            rows={3}
            maxLength={MAX_ANSWER_LENGTH}
            required
          />
        </label>
      ))}
    </fieldset>
  );
}
